/**
 * Automation trigger type constants and utilities.
 * Single source of truth for all trigger-related logic.
 */

export const TIME_BASED_TRIGGERS = [
  'stage_duration',
  'days_since_reply',
  'days_since_sent',
  'days_since_company_updated',
  'days_since_deal_updated',
] as const

export const DAYS_SINCE_TRIGGERS = [
  'days_since_reply',
  'days_since_sent',
  'days_since_company_updated',
  'days_since_deal_updated',
] as const

export type TimeBasedTrigger = (typeof TIME_BASED_TRIGGERS)[number]
export type DaysSinceTrigger = (typeof DAYS_SINCE_TRIGGERS)[number]

/**
 * Check if a trigger type is time-based
 */
export const isTimeBasedTrigger = (
  trigger: string | null | undefined
): trigger is TimeBasedTrigger => {
  if (!trigger) return false
  return TIME_BASED_TRIGGERS.includes(trigger as TimeBasedTrigger)
}

/**
 * Check if a trigger type is a "days since" trigger
 */
export const isDaysSinceTrigger = (
  trigger: string | null | undefined
): trigger is DaysSinceTrigger => {
  if (!trigger) return false
  return DAYS_SINCE_TRIGGERS.includes(trigger as DaysSinceTrigger)
}

/**
 * Check if a trigger type is stage duration
 */
export const isStageDuration = (
  trigger: string | null | undefined
): boolean => {
  return trigger === 'stage_duration'
}

/**
 * Default comparison operator for stage duration triggers
 * (implicit "HAS BEEN ... FOR" pattern means >=)
 */
export const STAGE_DURATION_DEFAULT_OPERATOR = 'greater_than_equal'

/**
 * Default duration unit for "days since" triggers
 * (implicit in the trigger name)
 */
export const DAYS_SINCE_DEFAULT_UNIT = 'days'
